module.exports = __webpack_public_path__ + "media/images/icon_learn-b99b24ae7f8fd044763c299be72fcdb1.svg";